<template>
  <div class="common-layout mobile-account-page">
    <MobileAccountHeader
      v-if="isMobileViewport"
      :return-label="$t('views.account_center.return')"
      :title="$t('views.account_center.account_center')"
      @close="$emit('close')"
    />
    <MobileAccountNav
      v-if="isMobileViewport"
      ref="mobileNav"
      :menu-items="mobileMenuItems"
      :active-menu="activeMenu"
      @select="$emit('select', $event)"
    />
    <slot />
  </div>
</template>

<script>
import MobileAccountHeader from './components/MobileAccountHeader.vue'
import MobileAccountNav from './components/MobileAccountNav.vue'

export default {
  name: 'MobileAccountPage',
  components: { MobileAccountHeader, MobileAccountNav },
  props: {
    isMobileViewport: Boolean,
    activeMenu: { type: String, required: true }
  },
  emits: ['close', 'select'],
  computed: {
    mobileMenuItems() {
      return [
        { label: this.$t('views.account_center.account_settings'), value: 'account_set' },
        { label: this.$t('views.account_center.preferences'), value: 'preference_set' },
        { label: this.$t('views.account_center.subscription_management'), value: 'subscription_manage' },
        { label: this.$t('views.account_center.bill'), value: 'bill_manage' },
        { label: this.$t('views.account_center.consumption_records'), value: 'consumption_records' }
      ]
    }
  },
  methods: {
    scrollActiveNavIntoView() {
      this.$refs.mobileNav?.scrollActiveNavIntoView()
    }
  }
}
</script>

<style scoped lang="scss">
@import './styles/index';
</style>
